import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { HolidayListComponent } from './holiday-list/holiday-list.component';
import { HolidayPerMonthListComponent } from './holiday-per-month-list/holiday-per-month-list.component';
import { HolidayPerMonthListFiltersComponent } from './holiday-per-month-list-filters/holiday-per-month-list-filters.component';



@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    HolidayListComponent,
    HolidayPerMonthListComponent,
    HolidayPerMonthListFiltersComponent
  ],
  exports: [
    HolidayListComponent
  ]
})
export class HolidaysModule { }
